module.exports = __webpack_public_path__ + "static/media/lazyaz_app2.4a659d9f.jpg";